import { TinyColor } from '@ctrl/tinycolor'

type ButtonStateColors = {
  text: string
  background: string
  border: string
}

export type ColorPalette = {
  tinyColor: TinyColor
  default: ButtonStateColors
  hover: ButtonStateColors
  focus: ButtonStateColors
  active: ButtonStateColors
  disabled: ButtonStateColors
}

function createColorPalette(primary: string): ColorPalette {
  const primaryColor = new TinyColor(primary)
  const textOnPrimary = primaryColor.isLight() ? '#000' : '#fff'

  return {
    tinyColor: primaryColor,
    default: {
      text: textOnPrimary,
      background: primaryColor.toHexString(),
      border: primaryColor.toHexString(),
    },
    hover: {
      text: textOnPrimary,
      background: primaryColor.clone().lighten(15).toHexString(),
      border: primaryColor.clone().lighten(15).toHexString(),
    },
    focus: {
      text: textOnPrimary,
      background: primaryColor.clone().darken(15).toHexString(),
      border: primaryColor.clone().darken(15).toHexString(),
    },
    active: {
      text: textOnPrimary,
      background: primaryColor.clone().darken(15).toHexString(),
      border: primaryColor.clone().darken(15).toHexString(),
    },
    disabled: {
      text: primaryColor.clone().desaturate(50).lighten(40).toHexString(),
      background: primaryColor.clone().desaturate(50).lighten(30).toHexString(),
      border: primaryColor.clone().desaturate(50).lighten(30).toHexString(),
    },
  }
}

export default createColorPalette
